/**
 * Application Configuration
 * 
 * This file contains all the configuration values for the TokLive Agency Dashboard.
 * Centralizing these values makes it easier to maintain and update the application.
 */

const appConfig = {
  // Application Information
  appName: 'TokLive Agency Dashboard',
  
  // Parse Server Configuration
  parseServer: {
    applicationId: 'Iuuvr3phwsA6dv8iJgSA9WfFJnJ3siTUHnjRLJ5O',
    serverUrl: 'https://api.toklive.me/1/',
    javascriptKey: 'dbKfy3KJSAy14J1no7xy2uNgBTnHJTgsQfORL3Ui'
  },
  
  // App Store Links
  appStoreLinks: {
    ios: 'https://apps.apple.com/app/toklive',
    android: 'https://play.google.com/store/apps/details?id=com.toklive'
  },
  
  // Social Media Links
  socialMedia: {
    facebook: 'https://facebook.com/tokliveapp',
    twitter: 'https://twitter.com/tokliveapp',
    instagram: 'https://instagram.com/tokliveapp'
  },

  // Social Login Configuration
  socialLogin: {
    facebook: {
      appId: '1604713750923624', // Facebook App ID
      version: 'v18.0'
    },
    google: {
      clientId: '984618385506-fu17hsgcpcab032rpg2p0cekerf67ibl.apps.googleusercontent.com' // Google Client ID
    },
    apple: {
      clientId: '123456789', // Apple Client ID
      scope: 'name email',
      redirectURI: window.location.origin
    }
  },
  
  // Support Information
  support: {
    email: 'support@toklive.me',
    helpCenter: 'https://help.toklive.me'
  },
  
  // API Endpoints
  apiEndpoints: {
    base: 'https://api.toklive.me',
    auth: '/auth',
    users: '/users',
    streams: '/streams',
    hosts: '/hosts'
  }
};

export default appConfig;
